<template>
  <el-date-picker
    v-model="val"
    :size='size'
    :style='cssStyle'
    :type="type"
    :format="format"
    :clearable='clearable'
    :disabled='disabled'
    :value-format="valueFormat"
    :range-separator="rangeSeparator"
    :start-placeholder="startPlaceholder"
    :end-placeholder="endPlaceholder"
    :picker-options="pickerOptions"
    @change="$emit('change', $event)">
  </el-date-picker>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    size: {
      default: "mini"
    },
    cssStyle: {
      default: "width: 100%"
    },
    type: {
      default: "daterange"
    },
    clearable: {
      default: true
    },
    disabled: {
      default: false
    },
    format: {
      default: "yyyy-MM-dd"
    },
    valueFormat: {
      default: "yyyy-MM-dd"
    },
    rangeSeparator: {
      default: "至"
    },
    startPlaceholder: {
      default: "开始日期"
    },
    endPlaceholder: {
      default: "结束日期"
    },
    pickerOptions: {
      default: function() {
        return {
          disabledDate(time) {
            return false;
          }
        }
      }
    },
    value: {},
  },
  data() {
    return {
      val: this.value
    }
  },
  watch: {
    value: function(value) {
      this.val = value;
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cx/cxDatePicker.vue